require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ru-pages-hotel-partner.json") })
        }
      }, "path---ru-pages-hotel-partner");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ru-pages-hotel-partner!./.cache/json/ru-pages-hotel-partner.json
// module id = 796
// module chunks = 231608221292675